(function() {    
    initSwitchery()

    function initSwitchery() {
        $('.js-switch:not([data-switchery])')
            .toArray()
            .forEach(function(html) {
                new Switchery(html, {
                    color: '#1c84c6',
                    size: 'small'
                });
            })
    }

    $(document).on('change:dom', initSwitchery)
})();
